'use client';

import Button from '@/components/shared/Button';
import Heading from '@/components/shared/Heading';
import Image from '@/components/shared/Image';
import Text from '@/components/shared/Text';
import { TextBlock } from '@/components/ui/Banner';
import { sheetStore } from '@/components/ui/ProductLayout/stores/sheetStore';
import type { Media } from '@/graphql/common/types';
import { RepresentativesSheet } from './RepresentativesSheet';

type RepresentativesProps = {
  title?: string;
  description?: string;
  media?: Media;
  representativeSheet?: {
    title: string;
    description?: string;
    buttonName?: string;
    file?: {
      name: string;
      url: string;
    };
    representatives: {
      id: string;
      title: string;
      file?: {
        name: string;
        url: string;
      };
    }[];
  };
};

export const Representatives = ({
  title = 'Representantes AXA',
  description,
  media,
  representativeSheet
}: RepresentativesProps) => {
  const setOpenSheetRepresentatives = sheetStore((state) => state.setOpenSheetPartners);

  return (
    <>
      <section className="bg-white py-10 lg:py-0">
        <div className="grid gap-10 lg:grid-cols-2 lg:gap-0 3xl:max-w-screen-2xl">
          <div className="flex items-center px-6 lg:px-12 2xl:px-[7.5rem]">
            <TextBlock
              mainText={
                <Heading variant="h3" display className="text-blue-500" asChild>
                  <h2>{title}</h2>
                </Heading>
              }
              customButtons={
                representativeSheet && (
                  <Button className="text-white" onClick={() => setOpenSheetRepresentatives(true)}>
                    Lista completa
                  </Button>
                )
              }
            >
              {description && (
                <Text className="mt-4 max-w-[540px] text-grey-700">{description}</Text>
              )}
            </TextBlock>
          </div>
          {media && (
            <div className="px-6 lg:px-12 lg:py-10 2xl:px-20">
              <Image
                src={media.url}
                alt={media.alternativeText || 'Representantes AXA'}
                width={media.width}
                height={media.height}
                className="object-cover object-center"
              />
            </div>
          )}
        </div>
      </section>

      <RepresentativesSheet representativeSheet={representativeSheet} />
    </>
  );
};
